<template>
  <app-page-container>
    <app-spinner v-if="!is_page_loaded" />
    <template v-else>
      <h2 class="title title--mb15">Altezza Cars</h2>
      <v-client-table
        :data="table_altezza.items"
        :columns="table_altezza.columns"
        :options="table_altezza.options"
        class="table-default"
      >
        <template #h__car>
          <div class="table-default__left">Car</div>
        </template>
        <template #h__driver>
          <div class="table-default__left">Driver</div>
        </template>
        <template #car="{ row }">
          <div class="table-default__left">
            {{ row.plate_number }}
          </div>
        </template>
        <template #driver="{ row }">
          <div class="table-default__left">
            <template v-if="row.driver">{{ row.driver.full_name }}</template>
            <template v-else>-</template>
          </div>
        </template>
        <template #year="{ row }">
          {{ row.year || '-' }}
        </template>
        <template #seats="{ row }">
          {{ row.seats || '-' }}
        </template>
        <template #type>
          <span class="status-title" style="background-color: #7ca500">Luxury</span>
        </template>
      </v-client-table>
      <h2 class="title title--mb15 title--mt30">Rental Companies</h2>
      <v-client-table
        :data="table_company.items"
        :columns="table_company.columns"
        :options="table_company.options"
        class="table-default table-default--small-cell"
      >
        <template #h__name><div class="table-default__left">Name</div></template>
        <template #name="{ row }">
          <div class="table-default__left">
            {{ row.name }}
          </div>
        </template>
        <template #count="{ row }">
          {{ row.available_cars_count }}
        </template>
      </v-client-table>
      <app-cells :indent="false" margin-top="30px" margin-bottom="15px">
        <h2 class="title">Rental Cars</h2>
        <app-select
          @input="fetchRentalCarsItems"
          v-model="filter_rental_company"
          :options="company_options"
          :clearable="true"
          placeholder="Rental company"
          class="select--200"
        />
      </app-cells>
      <v-client-table
        :data="table_rental.items"
        :columns="table_rental.columns"
        :options="table_rental.options"
        class="table-default table-default--small-cell"
      >
        <template #h__rental_company><div class="table-default__left">Company</div></template>
        <template #rental_company="{ row }">
          <div class="table-default__left">
            {{ row.rental_company.name }}
          </div>
        </template>
        <template #car="{ row }">
          <router-link
            :to="{ name: 'safari-cars-detail', params: { id: row.id } }"
            class="table-default__link-border table-default__link-border--inline"
          >
            {{ row.plate_number }}
          </router-link>
        </template>
        <template #located="{ row }">
          {{ row.located || '-' }}
        </template>
        <template #year="{ row }">
          {{ row.year || '-' }}
        </template>
        <template #seats="{ row }">
          {{ row.seats || '-' }}
        </template>
        <template #type="{ row }">
          <span v-if="row.car_type" class="status-title" :style="{ 'backgroundColor': row.car_type.color }">
            {{ row.car_type.name }}
          </span>
          <template v-else>-</template>
        </template>
      </v-client-table>
    </template>
  </app-page-container>
</template>

<script>
import {
  getCarManagementCars,
  getSafariRentalCars,
  getSafariRentalCompany,
  getSafariRentalCompanyAvailableCars
} from '@/http'

export default {
  name: 'AvailableCars',
  props: { reservationData: Object },
  data () {
    return {
      is_page_loaded: false,
      table_altezza: {
        items: [],
        columns: ['car', 'driver', 'year', 'seats', 'type'],
        options: {
          headings: {
            car: 'Car',
            driver: 'Driver',
            year: 'Year',
            seats: 'Seats',
            type: 'Type',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_rental: {
        items: [],
        columns: ['rental_company', 'car', 'located', 'year', 'seats', 'type'],
        options: {
          headings: {
            rental_company: 'Company',
            car: 'Car',
            located: 'Located',
            year: 'Year',
            seats: 'Seats',
            type: 'Type',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_company: {
        items: [],
        columns: ['name', 'count'],
        options: {
          headings: {
            name: 'Name',
            count: 'Count',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      company_options: [],
      filter_rental_company: null
    }
  },
  created () {
    Promise.all([
      getCarManagementCars({
        safari_tour_start: this.reservationData.tour_start,
        safari_tour_finish: this.reservationData.tour_end,
        safari: true
      }),
      getSafariRentalCars({
        safari_tour_start: this.reservationData.tour_start,
        safari_tour_finish: this.reservationData.tour_end
      }),
      getSafariRentalCompanyAvailableCars({
        safari_tour_start: this.reservationData.tour_start,
        safari_tour_finish: this.reservationData.tour_end
      })
    ])
      .then(result => {
        this.table_altezza.items = result[0].data
        this.table_rental.items = result[1].data
        this.table_company.items = result[2].data
        this.company_options = result[2].data
        this.is_page_loaded = true
      })
  },
  methods: {
    fetchRentalCarsItems() {
      getSafariRentalCars({
        safari_tour_start: this.reservationData.tour_start,
        safari_tour_finish: this.reservationData.tour_end,
        rental_company: this.filter_rental_company ? this.filter_rental_company.id : null,
      })
        .then(result => {  this.table_rental.items = result.data })
    }
  }
}
</script>
